<script>
import Page from '../../components/page.vue'
import Pull from  '../../components/pull.vue'
import Production from './production.vue'
import Item from './item.vue'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import { getPortalInfo } from '@/api/portal'
import { isInternallink } from '../../config/host'
import { app } from '../../cordova-plugins/custom-plugins'

const MAX_LENGTH = 6
export default {
  components: {
    Page,
    Pull,
    Production,
    Item
  },
  data () {
    return {
      banners: [],
      bookList: [],
      courseList: []
    }
  },
  async mounted () {
    await this.fetch()
    // eslint-disable-next-line
    new Swiper(this.$refs.swiper, {
      effect: 'coverflow',
      loop: true,
      centeredSlides: true,
      slidesPerView: 1.1,
      coverflowEffect: {
        rotate: 40,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: false
      }
    })
  },
  methods: {
    async fetch () {
      const { data } = await getPortalInfo()
      this.banners = data.banners
      this.bookList = this.normalizeBooklist((data.latestOnlines || []).slice(0, MAX_LENGTH))
      this.courseList = this.normalizeCourselist((data.populars || []).slice(0, MAX_LENGTH))
    },
    /**
     * @param target {string} item.link
     * @param title {string} item.title
     */
    bannerLink (target, title) {
      const url = new URL(target)
      if (isInternallink(url.host)) {
        if (url.pathname === '/web/web!courseDetail.do') {
          const id = url.searchParams.get('courseID')
          if (id) {
            this.$router.push({
              name: 'courseDetail',
              params: { id }
            })
            return
          }
        } else if (url.pathname === '/web/web!bookDetail.do') {
          const id = url.searchParams.get('bookId')
          if (id) {
            this.$router.push({
              name: 'bookDetail',
              params: { id }
            })
            return
          }
        }
      }
      app.openNewWindow(target)
    },
    normalizeBooklist (list) {
      return list.map(it => ({
        id: it.bookId,
        author: it.authors,
        cover: it.bookCover,
        name: it.bookName
      }))
    },
    normalizeCourselist (list) {
      return list.map(it => ({
        id: it.courseId,
        cover: it.courseCover,
        author: it.opencourseschool,
        name: it.courseName
      }))
    },
    viewLink (item) {
      // window.location = item.link
    }
  }
}
</script>

<template>
  <Page :headerBar="false">
    <Pull
      :pullDownMethod="fetch" :initialLoad="false"
    >
      <div class="swiper-container" :class="$style.swiperContainer" ref="swiper">
        <div class="swiper-wrapper">
          <img
            :src="$getThumbnail(item.bannerUrl, 0, 177)"
            :alt="item.title"
            height="177"
            class="swiper-slide"
            :class="$style.swiperCover"
            v-for="item in banners"
            :key="item.bannerID"
            :title="item.title"
            @click="viewLink(item)"
          />
        </div>
      </div>
      <div :class="$style.navLinks">
        <router-link :class="$style.bookLink" to="/books">
          <i class="iconfont iconxuekefenlei"></i>图书中心
        </router-link>
        <router-link :class="$style.courseLink" to="/course">
          <i class="iconfont iconkouyu_ceyannor"></i>课程中心
        </router-link>
      </div>
      <Production
        title="推荐图书"
        linkText="全部图书"
        linkUrl="/books"
        :list="bookList"
        :gutter="8"
        :span="4"
      >
        <template v-slot="{ item, index }">
          <Item :item="item" routename="bookDetail" :coverClass="$style.bookCover" />
        </template>
      </Production>
      <Production
        title="推荐课程"
        linkText="全部课程"
        linkUrl="/course"
        :list="courseList"
        :gutter="5"
        :span="6"
      >
        <template v-slot="{ item, index }">
          <Item :item="item" routename="courseDetail" :coverClass="$style.courseCover" />
        </template>
      </Production>
    </Pull>
  </Page>
</template>

<style lang="stylus" module>
.swiperContainer {
  padding: 30px 0 20px;
  background-color: #fff;
}

.swiperCover {
  display: block;
  width: 100%;
  height: 177px;
  object-fit: cover;
}

.navLinks {
  display: flex;
  page-gutter();
  padding-bottom: 22px;

  a {
    flex: 1;
    margin-right: 12px;
    text-align: center;
    height: 48px;
    line-height: 48px;
    font-size: 18px;
    color: #fff;
    box-shadow: 0 2px 4px 0 rgba(255, 94, 82, 0.5);
    border-radius: 4px;

    &:last-child {
      margin-right: 0;
    }
  }

  :global(.iconfont) {
    font-size: 24px;
    margin-right: 8px;
    vertical-align: middle;
  }

  /.bookLink {
    background-color: $primary-color;
  }

  /.courseLink {
    background-color: #FFB83A;
  }
}

.bookCover {
  height: 145px;
}

.courseCover {
  height: 93px;

  img {
    border-radius: 4px;
  }
}
</style>
